
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiTwowayDigitalOpen as ObiTwowayDigitalOpenElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-twoway-digital-open.js';
 
 
 

 
 export const ObiTwowayDigitalOpen = createComponent({
   react: React,
   tagName: 'obi-twoway-digital-open',
   elementClass: ObiTwowayDigitalOpenElement,
   events: {
     
   }
  });
 
 